module.exports = __webpack_public_path__ + "img/installer-sample-avatar.6ecd468a.svg";